import { TFunction } from 'i18next';

export const getValidationMessages = (t: TFunction) => ({
  title: {
    required: t('guides.modal.validation.title.required'),
    minLength: t('guides.modal.validation.title.minLength'),
    maxLength: t('guides.modal.validation.title.maxLength'),
  },
  stepTitle: {
    required: t('guides.modal.validation.stepTitle.required'),
  },
  description: {
    maxLength: t('guides.modal.validation.description.maxLength'),
  },
  difficulty: {
    required: t('guides.modal.validation.difficulty.required'),
  },
  estimatedTime: {
    maxLength: t('guides.modal.validation.estimatedTime.maxLength'),
  },
  file: {
    required: t('guides.modal.validation.file.required'),
    invalidType: t('guides.modal.validation.file.invalidType'),
    maxSize: t('guides.modal.validation.file.maxSize'),
  },
  pdfUrl: {
    required: t('guides.modal.validation.pdfUrl.required'),
    invalidUrl: t('guides.modal.validation.pdfUrl.invalidUrl'),
    invalidPdfUrl: t('guides.modal.validation.pdfUrl.invalidPdfUrl'),
  },
});

export type ValidationMessages = ReturnType<typeof getValidationMessages>;
